import { IDSK, Replace, Resource } from "@examspark/types";

import { GraphQLAPI } from "../../client";
import * as fragments from "../../fragments/resource";
import { exam } from "../../queries";
import { getResource } from "../resource";

export const getExam = async (params: IDSK) => {
  return (
    await getResource({
      label: "GetExam",
      variables: params,
      fields: `
      ${fragments.id}
      ${fragments.basic}
      workspace {
        id
        name
      }
      ${fragments.examContent}
      creatorId
      isDeleted
      grade
      subject
      resourceId
      appId
      questionIds
      questions {
        ${fragments.id}
        name
        ${fragments.alignments}
      }
      config
    `,
    })
  ).data?.getResource;
};

// useExam.GetExam
export const getExamBasic = async (
  params: Replace<IDSK, { sk: `exam#v${number}` }>,
) => {
  return (
    await getResource({
      label: "GetExamBasic",
      variables: params,
      fields: `
        id
        sk
        schemaVersion
        idInc
        idVendor
        type
        version
        resourceId
        bankId
        workspaceId
        name
        description
        appId
      `,
    })
  ).data?.getResource;
};

/**
 * This was used to support the LTI launch route where an existing exam config
 * can be edited. The route is not fully supported at this time, but is
 * requested by Learning Explorer.
 */
export const getExamDataForPlayerViaExamConfig = async (params: IDSK) => {
  return (
    await getResource({
      label: "GetExamData",
      variables: params,
      fields: `
      ${fragments.id}
      ${fragments.basic}
      bankId
      workspace {
        id
        name
      }
      ${fragments.examContent}
      creatorId
      schemaVersion
      alignmentIds
      isDeleted
      questionIds
      questions {
        ${fragments.id}
        name
        ${fragments.itemContent}
        ${fragments.contexts}
      }
      config
      resource {
        ${fragments.id}
        ${fragments.basic}
        bankId
        workspace {
          id
          name
        }
        ${fragments.examContent}
        creatorId
        schemaVersion
        alignmentIds
        isDeleted
        questionIds
        questions {
          ${fragments.id}
          name
          ${fragments.itemContent}
          ${fragments.contexts}
        }
        config
      }
    `,
    })
  ).data?.getResource;
};

export const getExamDataForPlayer = async (params: IDSK) => {
  return (
    await getResource({
      label: "GetExamData",
      variables: params,
      fields: `
      ${fragments.id}
      ${fragments.basic}
      bankId
      workspace {
        id
        name
      }
      ${fragments.examContent}
      creatorId
      schemaVersion
      alignmentIds
      isDeleted
      questionIds
      questions {
        ${fragments.id}
        name
        ${fragments.alignments}
        ${fragments.itemContent}
        ${fragments.contexts}
      }
      config
      ${fragments.tags}
    `,
    })
  ).data?.getResource;
};

export const getPlayableExam = async (
  params: Replace<IDSK, { sk: `exam#v${number}` }>,
) => {
  return GraphQLAPI.query<{ getPlayableExam: Resource }>({
    query: exam.getPlayableExamQuery,
    variables: {
      input: {
        id: params.id,
        sk: params.sk,
      },
    },
  }).then((result) => result.data?.getPlayableExam ?? null);
};

export const getPrintableExam = async (
  params: Replace<IDSK, { sk: `exam#v${number}` }>,
) => {
  return GraphQLAPI.client
    .query<{ getPrintableExam: Resource }>({
      query: exam.getPrintableExamQuery,
      variables: {
        input: {
          id: params.id,
          sk: params.sk,
        },
      },
    })
    .then((result) => result.data?.getPrintableExam ?? null);
};
